import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, reset } from "redux-form";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  COMMON_FAIL_MESSAGE,
  validateEmail,
  validateUrl,
  DEVELOPMENT_TYPE,
  maxLengthObjectFc,
  DOMAIN_NAME,
} from "Constants";
import {
  fetchSettings,
  addSetting,
  updateSetting,
  updateFormid,
  openTermsModal,
} from "TicketAction";
import { BaseComponent, number } from "BaseComponent";
import AddForm from "../form-builder/add-form";
import EditForm from "../form-builder/edit-form";
import RichTextTinymceEditor from "RichTextTinymceEditor";
import DefaultTerms from "./default_terms.js";
import draftToHtml from "draftjs-to-html";
import LocaleStrings from "Languages";
import EventPolicySetting from "EventPolicySetting";
var MAXLENOBJ = {};

class Setting extends BaseComponent {
  constructor(props) {
    super(props);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.state = { loading: false, thankyoupagetype: "" };
  }

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history);
    this.props.fetchSettings(this.props.session);
  }

  renderCustomSelect(field) {
    var divClassName = `row form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    return (
      <div className={divClassName}>
        <label className="control-label-top col-sm-12">
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>
        <div className="col-sm-12 col-sm-offset-0">
          <select className="form-control" {...field.input}>
            <option value="" key={field.label}>
              {field.placeholder}
            </option>
            {field.opts.map((object, index) => {
              return (
                <option key={`${object.value}-${index}`} value={object.value}>
                  {object.name}
                </option>
              );
            })}
          </select>
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderFieldText(field) {
    let charactersLeft = "";
    var { labelposition } = field;
    var divClassName = `row form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label-top col-sm-12";
    var inputClasses = "col-sm-12 col-sm-offset-0";
    if (field.maxlength) {
      charactersLeft = field.maxlength - field.input.value.length;
    }
    return (
      <div className={divClassName}>
        {field.input.name == "tax" ? (
          <label className={labelClasses}>
            {field.label}{" "}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>{" "}
            <span style={{ fontSize: 10 }}>
              (
              {LocaleStrings.tickets_setting_text_tax_will_apply_on_all_tickets}
              )
            </span>
          </label>
        ) : (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        )}
        <div className={inputClasses} style={{ position: "relative" }}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            disabled={field.disabled}
            min={field.min ? field.min : ""}
            max={field.max ? field.max : ""}
            maxLength={field.maxlength ? field.maxlength : ""}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
          {field.maxlength ? (
            <span className="char-left">
              {field.input.value.length}
              {" / "}
              {field.maxlength}
            </span>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }

  renderRichTextareaWithLabel(field) {
    var divClassName = `row form-group ${field.meta.error ? "has-danger" : ""}`;
    divClassName = `${divClassName}`;

    var labelClasses = "control-label-top col-sm-12";
    var inputClasses = "col-sm-12 col-sm-offset-0";

    return (
      <div className={divClassName}>
        <label className={labelClasses}>
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
          {field.url ? (
            <a className="ml-10" href={field.url} target="_blank">
              {field.url}
            </a>
          ) : (
            ""
          )}
          <a
            onClick={() => field.onClick(field.input.name)}
            className="custom-a-tag"
            style={{ float: "right" }}
          >
            {LocaleStrings.tickets_setting_form_text_sample_template}
          </a>
        </label>

        <div className={inputClasses}>
          <RichTextTinymceEditor type={field.type} {...field} />
          <div className="text-help label-text-help">
            {field.meta.error ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderTicketSettingCheckbox(field) {
    var divClassName = `row form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    return (
      <div className={divClassName}>
        <div className="col-md-12">
          <label className="custom-container-checkbox mb-0">
            <input className="" type={field.type} {...field.input} />
            <span className="checkmark" />
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
            <a
              href={
                DEVELOPMENT_TYPE === "koachify"
                  ? "https://koachify.io/terms-of-service/"
                  : "https://eventify.io/terms-of-use/"
              }
              target="blank"
              style={{ float: "right", fontWeight: 700 }}
            >
              {
                LocaleStrings.tickets_setting_text_read_eventify_terms_conditions
              }
            </a>
            <div className="text-help label-text-help">
              {field.meta.touched ? field.meta.error : ""}
            </div>
          </label>
        </div>
      </div>
    );
  }

  openModel = (field) => {
    this.props.openTermsModal({ showModal: true, open: field });
  };

  onSubmitForm(values) {
    // console.log("form submit values", values);

    var data;
    if (values.thankyoutype == "link") {
      values.thankyoulink = values.thankyoulink;
    } else {
      values.thankyoulink = null;
    }
    if (values.thankyoutype == "text") {
      values.congratulations = values.congratulations;
    } else {
      values.congratulations = null;
    }

    delete values["event_by_eventid"];
    delete values["event_forms_by_eventformid"];
    delete values["event_forms_by_exhibitorformid"];
    delete values["event_forms_by_sesseionratingformid"];
    delete values["event_forms_by_sponsorformid"];

    data = { ...values };

    this.setState({ loading: true });
    if (this.props.editMode) {
      this.props.updateSetting(data, this.props.session, (response) => {
        // console.log('response',response);
        if (response.success === 0) {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.setState({ loading: false });
          this.props.showSuccess(
            LocaleStrings.tickets_setting_form_setting_updated_success
          );
          this.props.reset();
        }
      });
    } else {
      this.props.addSetting(this.props.session, data, (response) => {
        // console.log('response',response);
        if (response.success === 0) {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.setState({ loading: false });
          this.props.showSuccess(
            LocaleStrings.tickets_setting_form_setting_added_success
          );
          this.props.reset();
        }
      });
    }
  }

  callbackForm = (res) => {
    // let {editMode, initialValues} = this.props;
    // // let formid = res.resource[0].formid;
    // let formid = res.newformid;
    // let id = 0;
    // if(initialValues && initialValues.id) {
    //   id = initialValues.id;
    // }

    // if(editMode && initialValues) {
    //   this.props.updateFormid(this.props.session, formid, id, (response) => {
    //     this.props.fetchSettings(this.props.session);
    //   });
    // }
    // else {
    //   let values = {eventformid: formid};
    //   this.props.addSetting(this.props.session,values,(response) => {
    //     this.props.fetchSettings(this.props.session);
    //   });
    // }

    this.props.fetchSettings(this.props.session);
  };

  handleThankPagetype = (type) => {
    // console.log("type :- ", type);

    this.setState({ thankyoupagetype: type });
  };

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      editMode,
      initialValues,
      eventDetails,
      initVals,
      deviceSize,
    } = this.props;
    // console.log("initialValues :- ", eventDetails);
    let refundPolicy = [
      {
        name: "1 day: Attendees can receive refunds upto 1 day before the event start date",
        value: "1 day",
      },
      {
        name: "7 days: Attendees can receive refunds upto 7 days before the event start date",
        value: "7 days",
      },
      {
        name: "30 days: Attendees can receive refunds upto 30 days before the event start date",
        value: "30 days",
      },
      { name: "No refunds: We do not offer refunds", value: "No refunds" },
    ];
    let listingPrivacy = [
      { name: "Public", value: "public" },
      { name: "Private", value: "private" },
    ];

    let hrstyle = {
      margin: "0px 0px 15px 0px",
      borderTop: "1px solid #e6edf3",
    };

    var thankyoupagetype =
      this.state.thankyoupagetype != ""
        ? this.state.thankyoupagetype
        : initialValues.thankyoutype;

    let seocode =
      eventDetails && eventDetails.seocode
        ? eventDetails.seocode
        : "not-found-seocode";
    var termsconditionurl = eventDetails
      ? `https://${seocode}.${DOMAIN_NAME}/t/tickets/terms-conditions`
      : "";
    var privacypolicyurl = eventDetails
      ? `https://${seocode}.${DOMAIN_NAME}/t/tickets/privacy-policy`
      : "";

    // console.log("thankyoupagetype :- ", thankyoupagetype);

    return (
      <div
        className="panel-body scrollable-content-full-page"
        // style={{ height: deviceSize.height - 40, width: "100%" }}
      >
        {DEVELOPMENT_TYPE === "koachify" ? (
          ""
        ) : (
          <div className="row m-0">
            <div className="col-md-12 p-0">
              <label className="setting-company-section-heading">
                {LocaleStrings.basic_setting_user_registration_group}
              </label>
              <hr style={hrstyle} />
              <EventPolicySetting />
            </div>

            {/* <div className="col-md-12 p-0">
              <label className="setting-company-section-heading">
                {LocaleStrings.basic_setting_dynamic_form_group}
              </label>
              <hr style={hrstyle} />
              {initialValues && initialValues.eventformid ? (
                <EditForm
                  formDetails={initialValues.event_forms_by_eventformid}
                  formNameEdit={
                    initialValues.event_forms_by_eventformid.formname
                  }
                  formNumber={
                    initialValues.event_forms_by_eventformid.formnumber
                  }
                  version={initialValues.event_forms_by_eventformid.versionno}
                  formJson={initialValues.event_forms_by_eventformid.formjson}
                  calledFrom={this.callbackForm}
                />
              ) : (
                // <AddForm calledFrom={this.callbackForm}/>
                ""
              )}
            </div> */}
          </div>
        )}

        <DefaultTerms />

        <form onSubmit={handleSubmit(this.onSubmitForm)}>
          <div className="row m-0">
            <div className="col-md-12 p-0">
              <label className="setting-company-section-heading">
                {LocaleStrings.tickets_setting_form_organization_group}
              </label>
              <hr style={hrstyle} />
              <Field
                name="companyname"
                label={LocaleStrings.tickets_setting_form_label_company_name}
                placeholder={LocaleStrings.tickets_setting_form_ph_company_name}
                type="text"
                mandatory="true"
                component={this.renderFieldText}
                maxlength={MAXLENOBJ.companyname ? MAXLENOBJ.companyname : ""}
              />
              <Field
                name="companyaddress"
                label={LocaleStrings.tickets_setting_form_label_company_address}
                placeholder={
                  LocaleStrings.tickets_setting_form_ph_company_address
                }
                type="text"
                mandatory="true"
                component={this.renderFieldText}
                maxlength={
                  MAXLENOBJ.companyaddress ? MAXLENOBJ.companyaddress : ""
                }
              />
              <Field
                name="supportemail"
                label={LocaleStrings.tickets_setting_form_label_support_email}
                placeholder={
                  LocaleStrings.tickets_setting_form_ph_support_email
                }
                type="text"
                mandatory="true"
                component={this.renderFieldText}
              />
              <div className="row">
                <div className="col-md-4">
                  <Field
                    name="taxname"
                    label={LocaleStrings.tickets_setting_form_label_tax_name}
                    placeholder={LocaleStrings.tickets_setting_form_ph_tax_name}
                    type="text"
                    component={this.renderFieldText}
                    maxlength={MAXLENOBJ.taxname ? MAXLENOBJ.taxname : ""}
                  />
                </div>
                <div className="col-md-4">
                  <Field
                    name="tax"
                    label={
                      LocaleStrings.tickets_setting_form_label_tax_percentage
                    }
                    placeholder={
                      LocaleStrings.tickets_setting_form_ph_tax_percentage
                    }
                    type="text"
                    min={1}
                    max={30}
                    component={this.renderFieldText}
                  />
                </div>
                <div className="col-md-4">
                  <Field
                    name="company_number"
                    label={LocaleStrings.tickets_setting_form_label_cin}
                    placeholder={LocaleStrings.tickets_setting_form_ph_cin}
                    type="text"
                    component={this.renderFieldText}
                  />
                </div>
              </div>
              <label className="setting-company-section-heading">
                {LocaleStrings.tickets_setting_form_terms_conditions_group}
              </label>
              <hr style={hrstyle} />
              <Field
                name="refundpolicy"
                label={LocaleStrings.tickets_setting_form_label_refund_policy}
                placeholder={
                  LocaleStrings.tickets_setting_form_ph_refund_policy
                }
                type="select"
                mandatory="true"
                component={this.renderCustomSelect}
                opts={refundPolicy}
              />
              {/* <Field
                name="listingprivacy"
                label={LocaleStrings.tickets_setting_form_label_listing_privacy}
                placeholder={LocaleStrings.tickets_setting_form_ph_listing_privacy}
                type="select"
                mandatory="true"
                component={this.renderCustomSelect}
                opts={listingPrivacy}
              /> */}
              <Field
                name="privacy"
                label={LocaleStrings.tickets_setting_form_label_privacy_policy}
                placeholder={
                  LocaleStrings.tickets_setting_form_ph_privacy_policy
                }
                mandatory="true"
                type="minimal"
                component={this.renderRichTextareaWithLabel}
                url={privacypolicyurl}
                onClick={this.openModel}
                height={300}
              />
              <Field
                name="termsandconditions"
                label={
                  LocaleStrings.tickets_setting_form_label_terms_conditions
                }
                placeholder={
                  LocaleStrings.tickets_setting_form_ph_terms_conditions
                }
                mandatory="true"
                type="minimal"
                component={this.renderRichTextareaWithLabel}
                url={termsconditionurl}
                onClick={this.openModel}
                height={300}
              />
              <label className="setting-company-section-heading">
                {LocaleStrings.tickets_setting_form_organization_corner_group}
              </label>
              <hr style={hrstyle} />
              <div className="mb-20">
                <label
                  className="control-label-top m-0 mb-5"
                  style={{ padding: 0 }}
                >
                  {LocaleStrings.tickets_setting_form_label_thankyou_page_type}
                  <span className="label-mandatory">*</span>
                </label>
                <div
                  className="col-md-12"
                  style={{ padding: 0, display: "flex" }}
                >
                  <Field
                    name="thankyoutype"
                    label={
                      LocaleStrings.tickets_setting_form_text_thankyou_option1
                    }
                    component={this.renderFieldRadio}
                    type="radio"
                    value="text"
                    onChange={() => this.handleThankPagetype("text")}
                  />{" "}
                  <Field
                    name="thankyoutype"
                    label={
                      LocaleStrings.tickets_setting_form_text_thankyou_option2
                    }
                    component={this.renderFieldRadio}
                    type="radio"
                    value="link"
                    onChange={() => this.handleThankPagetype("link")}
                  />
                </div>
              </div>
              {thankyoupagetype == "link" ? (
                <Field
                  name="thankyoulink"
                  label={LocaleStrings.tickets_setting_form_label_thankyou_link}
                  placeholder={
                    LocaleStrings.tickets_setting_form_ph_thankyou_link
                  }
                  type="text"
                  mandatory="true"
                  component={this.renderFieldText}
                />
              ) : (
                <Field
                  name="congratulations"
                  label={
                    LocaleStrings.tickets_setting_form_label_congratulation_message
                  }
                  placeholder={
                    LocaleStrings.tickets_setting_form_ph_congratulation_message
                  }
                  type="minimal"
                  mandatory="true"
                  component={this.renderRichTextareaWithLabel}
                  maxlength={
                    MAXLENOBJ.congratulations ? MAXLENOBJ.congratulations : ""
                  }
                  onClick={this.openModel}
                  height={300}
                />
              )}
              <hr style={hrstyle} />
              <hr style={hrstyle} />
              <Field
                name="eventify_terms"
                label={
                  LocaleStrings.tickets_setting_form_label_eventify_terms_conditions
                }
                type="checkbox"
                mandatory="true"
                component={this.renderTicketSettingCheckbox}
              />
              <Button
                className="btn-custom-blue pull-left"
                bsStyle=""
                loading={this.state.loading}
                // disabled={pristine || invalid || submitting}
                type="submit"
              >
                {LocaleStrings.button_save}
              </Button>
              <div className="col-md-12" style={{ marginTop: 20 }}>
                <label className="">
                  {/* <span style={{color: 'red'}}>{LocaleStrings.note} : </span> {LocaleStrings.tickets_setting_note1} */}
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var initVals = { refundpolicy: "No refunds", thankyoutype: "text" };
  var toEdit = false;

  if (
    state.SettingData &&
    state.SettingData.resource &&
    state.SettingData.resource.length > 0
  ) {
    initVals = state.SettingData.resource[0];
    if (state.SettingData.resource[0].tax == "0") {
      initVals.tax = "";
    }
    if (
      !state.SettingData.resource[0].refundpolicy ||
      state.SettingData.resource[0].refundpolicy == ""
    ) {
      initVals.refundpolicy = "No refunds";
    }
    initVals.thankyoutype =
      state.SettingData.resource[0].thankyoulink &&
      state.SettingData.resource[0].thankyoulink != ""
        ? "link"
        : "text";

    toEdit = true;
  }

  // console.log('toEdit',toEdit);
  return {
    ticketMenus: state.ticketMenus,
    session: state.session,
    initialValues: initVals,
    editMode: toEdit,
    initVals,
    eventDetails: state.userEventDetails,
    deviceSize: state.deviceSize,
  };
}

function validate(values) {
  var errors = {};
  var companyname = values["companyname"];
  var companyaddress = values["companyaddress"];
  var supportemail = values["supportemail"];
  var refundpolicy = values["refundpolicy"];
  var listingprivacy = values["listingprivacy"];
  var privacy = values["privacy"];
  var termsandconditions = values["termsandconditions"];
  var thankyoutype = values["thankyoutype"];
  var thankyoulink = values["thankyoulink"];
  var congratulations = values["congratulations"];
  var eventify_terms = values["eventify_terms"];
  var tax = values["tax"];

  if (!companyname || companyname.trim() === "") {
    errors["companyname"] =
      LocaleStrings.tickets_setting_form_validation_required;
  }

  if (!companyaddress || companyaddress.trim() === "") {
    errors["companyaddress"] =
      LocaleStrings.tickets_setting_form_validation_required;
  }

  if (!supportemail || supportemail.trim() === "") {
    errors["supportemail"] =
      LocaleStrings.tickets_setting_form_validation_required;
  } else if (supportemail && !validateEmail(supportemail)) {
    errors["supportemail"] =
      LocaleStrings.tickets_setting_form_validation_invalid_email;
  }

  if (!refundpolicy) {
    errors["refundpolicy"] =
      LocaleStrings.tickets_setting_form_validation_required;
  }

  // if(!listingprivacy){
  //   errors['listingprivacy'] = LocaleStrings.tickets_setting_form_validation_required;
  // }

  if (!privacy || privacy.trim() === "") {
    errors["privacy"] = LocaleStrings.tickets_setting_form_validation_required;
  }

  if (!termsandconditions || termsandconditions.trim() === "") {
    errors["termsandconditions"] =
      LocaleStrings.tickets_setting_form_validation_required;
  }

  if (
    thankyoutype == "text" &&
    (!congratulations || congratulations.trim() === "")
  ) {
    errors["congratulations"] =
      LocaleStrings.tickets_setting_form_validation_required;
  } else if (thankyoutype == "link") {
    if (!thankyoulink || thankyoulink.trim() == "")
      errors["thankyoulink"] =
        LocaleStrings.tickets_setting_form_validation_required;
    else if (thankyoulink && !validateUrl(thankyoulink))
      errors["thankyoulink"] = LocaleStrings.invalid_url;
  }

  if (!eventify_terms) {
    errors["eventify_terms"] =
      LocaleStrings.tickets_setting_form_validation_required;
  }

  if (tax && !parseInt(tax, 10)) {
    errors["tax"] =
      LocaleStrings.tickets_setting_form_validation_only_positive_number;
  }
  if (tax && tax > 30) {
    errors["tax"] =
      LocaleStrings.tickets_setting_form_validation_tax_should_be_less_equal_30;
  }
  if (tax && tax < 1) {
    errors["tax"] =
      LocaleStrings.tickets_setting_form_validation_tax_should_not_be_less_equal_1;
  }

  if (values["companyname"] && MAXLENOBJ) {
    if (values["companyname"].length > MAXLENOBJ.companyname) {
      errors["companyname"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.companyname;
    }
  }

  if (values["companyaddress"] && MAXLENOBJ) {
    if (values["companyaddress"].length > MAXLENOBJ.companyaddress) {
      errors["companyaddress"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.companyaddress;
    }
  }

  if (values["taxname"] && MAXLENOBJ) {
    if (values["taxname"].length > MAXLENOBJ.taxname) {
      errors["taxname"] = LocaleStrings.max_characters_left + MAXLENOBJ.taxname;
    }
  }

  if (values["congratulations"] && MAXLENOBJ) {
    if (
      values["congratulations"].replace(/<[^>]+>/g, "").length >
      MAXLENOBJ.congratulations
    ) {
      errors["congratulations"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.congratulations;
    }
  }

  return errors;
}

export default connect(mapStateToProps, {
  fetchSettings,
  addSetting,
  updateSetting,
  updateFormid,
  showError,
  showSuccess,
  openTermsModal,
})(
  reduxForm({
    validate,
    form: "SettingForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(Setting)
);
